<div class="db-fc-dropdown-select">
  <span class="db-fc-dropdown-select__label" *ngIf="label">{{label}}</span>

  <div class="db-fc-dropdown-select__toggle" (click)="toggleDropdown()">
    <a class="db-fc-dropdown-select__chosen-option"  [ngClass]="{'db-fc-dropdown-select__chosen-option-selected': toggled}">
      <span>{{chosenOption ? chosenOption.label : placeHolder }}</span>
      <i class="db-icon db-icon-new-down-arrow" [ngClass]="{'db-icon-arrow-up': toggled}"></i>
    </a>
  </div>

  <div  class="db-fc-dropdown-select__content db-fc-dropdown-select__content_align_r {{positionCLassName}}" [ngClass]="{'db-fc-dropdown-select__content_toggled': toggled}">
    <div dbCustomScrollbar>
      <ul *ngIf="!trialFlow">
        <li *ngFor="let option of options">
          <a class="db-fc-dropdown-select__option" [ngClass]="{'db-disabled': (!option.value && option.label !== 'All Domains')}" (click)="onOptionClick($event, option)">
          <i class="db-icon db-icon-{{option.icon}}" *ngIf="option.icon"></i>
          <img *ngIf="option?.screenshot"
               [src]="(option?.screenshot ?  'data:image/jpg;base64,' + option?.screenshot : '../../../../assets/images/common/no_screenshot.svg')" alt=""/>
          <span>{{option.label}}</span>
          <b *ngIf="option.description" [innerHTML]="option.description | dbText"></b>
          </a>
        </li>
      </ul>
      <ul *ngIf="trialFlow">
        <li *ngFor="let option of availableOptions"><a class="db-fc-dropdown-select__option" [ngClass]="{'db-disabled': (!option.value && option.label !== 'All Domains'), 'db-disabled-datacenter': !option.isAvailable }" (click)="onOptionClick($event, option)"><i class="db-icon db-icon-{{option.icon}}" *ngIf="option.icon"></i><img
          *ngIf="option?.screenshot" [src]="(option?.screenshot ?  'data:image/jpg;base64,' + option?.screenshot : '../../../../assets/images/common/no_screenshot.svg')" alt=""/><span>{{option.label}}</span></a></li>
        <li *ngFor="let option of disabledOptions"><a class="db-fc-dropdown-select__option" [ngClass]="{'db-disabled': (!option.value && option.label !== 'All Domains'), 'db-disabled-datacenter': !option.isAvailable }" (click)="onOptionClick($event, option)"><i class="db-icon db-icon-{{option.icon}}" *ngIf="option.icon"></i><img
          *ngIf="option?.screenshot" [src]="(option?.screenshot ?  'data:image/jpg;base64,' + option?.screenshot : '../../../../assets/images/common/no_screenshot.svg')" alt=""/><span>{{option.label}}</span></a></li>
      </ul>
    </div>
  </div>
</div>
